module.exports = __webpack_public_path__ + "img/logo7.f4d21b42.jpg";